module.exports = __webpack_public_path__ + "static/img/IT.9cd390a.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/images/userTips/IT.png
// module id = M6Jc
// module chunks = 1